import React, { useState } from "react";
import PropTypes from "prop-types";
import "./TabButtons.scss"; // Use a common SCSS file for styling

const TabButtons = ({ tabs, onTabChange }) => {
  const [activeTab, setActiveTab] = useState(tabs[0].id);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    onTabChange(tabId); // Notify parent component about tab change
  };

  return (
    <div className="tabButtonsContainer">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          //className={`${tab.id} ${activeTab === tab.id ? "active" : ""}`}
          className="tabButtons"
          onClick={() => handleTabClick(tab.id)}
          style={{
            color: tab.id == activeTab ? "#393a3d" : "#6B6C73",
            background: tab.id == activeTab ? "#FFFFFF" : "#F4F5F8",
            borderTopLeftRadius:
              tab.id == tabs.length - 1
                ? "0"
                : tab.id > 0 && tab.id < tabs.length - 1
                ? "0"
                : "52px",
            borderTopRightRadius:
              tab.id == 0
                ? "0"
                : tab.id > 0 && tab.id < tabs.length - 1
                ? "0"
                : "52px",
            borderBottomLeftRadius:
              tab.id == tabs.length - 1
                ? "0"
                : tab.id > 0 && tab.id < tabs.length - 1
                ? "0"
                : "52px",
            borderBottomRightRadius:
              tab.id == 0
                ? "0"
                : tab.id > 0 && tab.id < tabs.length - 1
                ? "0"
                : "52px",
            borderRight:
              tab.id == tabs.length - 1
                ? "1px solid var(--Gray-05, #d2d7de)"
                : "",
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

TabButtons.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default TabButtons;
